var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#006aff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 20,
    strokeDashoffset: 20,
    d: "M3 21h18"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "0.3s",
    values: "20;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 48,
    strokeDashoffset: 48,
    d: "M7 17v-4l10 -10l4 4l-10 10h-4"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.3s",
    dur: "0.9s",
    values: "48;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 8,
    strokeDashoffset: 8,
    d: "M14 6l4 4"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "1.2s",
    dur: "0.3s",
    values: "8;0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006aff",
    fillOpacity: 0,
    d: "M14 6l4 4L21 7L17 3Z"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "fill-opacity",
    begin: "1.65s",
    dur: "0.225s",
    values: "0;0.35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoEditIcon);
export default __webpack_public_path__ + "static/media/trvto_edit_icon.4d4011ac9cbcc86177c58307cb2043ad.svg";
export { ForwardRef as ReactComponent };